<template>
  <v-row no-gutters class="wrapper">
    <v-col sm="12" md="3" class="title-text" :style="{ fontSize }">
      {{ this.text }}
    </v-col>
    <v-col sm="12" md="9">
      <v-switch
        class="ml-4"
        color="primary"
        v-model="inputVal"
        hide-details
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "TitleWithSwitch",
    props: {
      modelValue: { type: Boolean, default: false },
      text: { type: String, default: "" },
      fontSize: { type: String, default: "14px" }
    },
    computed: {
      inputVal: {
        get () {
          return this.modelValue
        },
        set (val) {
          this.$emit("update:modelValue", val)
        }
      }
    },
    emits: ["input"]
  }
</script>

<style scoped>
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title-text {
    display: block;
    font-weight: bold;
    white-space: nowrap;
  }
</style>
